"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTestingMiddleware = void 0;
var createTestingMiddleware = function () {
    return function () {
        return function (next) {
            return function (action) {
                if (window.interceptDispatch) {
                    if (window.interceptDispatch(action)) {
                        return next(action);
                    }
                }
                else {
                    return next(action);
                }
            };
        };
    };
};
exports.createTestingMiddleware = createTestingMiddleware;
